import { List, ListItem } from "@mui/material";
import { Ladestasjon } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import CharingStationIconResource from "../../assets/chargingstation.svg"

export default function Ladestasjoner(props: IRoutePartProps) {
    
    return (   
        <>
            {props.roadFeatures && props.roadFeatures.ladestasjoner && props.roadFeatures.ladestasjoner.length > 0 &&
            <List>
                {props.roadFeatures.ladestasjoner.map( (ladestasjon: Ladestasjon, index: number) => (
                    <ListItem 
                        key={ladestasjon.csmdId + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(ladestasjon, event)}}
                        onMouseEnter={() => { props.onMouseEnterItem(ladestasjon)}}
                        onMouseLeave={props.onMouseLeaveItem}>
                        <img src={CharingStationIconResource} height="24"  style={{paddingRight:"5px"}} alt="Ladestajon icon" title="ladestasjonIcon"/> 
                        {"ladestasjon: " + ladestasjon.csmdId}
                    </ListItem>
                ))}
            </List>        
            }
        </>     
    )
}